module.exports = __webpack_public_path__ + "img/logo2.ba7d8258.png";